import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { YSButton } from "../../../uikit/YSButton";
import { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import {
  greyColor,
  warnColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
  DRxInputStyle,
  DRxSelectStyle,
  TelephoneStyle,
} from "../../../Theme";
import DRxInput from "../../../uikit/DRxInput";
import { useSelector } from "react-redux";
import useFetch from "../../../CustomHooks/useFetch";
import {
  InitializeAddClinic,
  MyProfileAddNewClinic,
} from "../../../Apis/AuthApiServices";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import YSSnackBar from "../../../uikit/YSSnackBar";

const initialStateAddClinic = {
  addressLineOne: "",
  addressLineTwo: "",
  location: "",
  telephoneNo: "",
  telephoneNo1: "",
  telephoneNo2: "",
  faxNo: "",
  faxNo1: "",
  faxNo2: "",
  clinicExtraLocation: "",
  city: "",
  zip: "",
  state: "",
  npi: "",
  stateLicenseId: "",
  deaNo: "",
};

export default function AddNewClinic(props: any) {
  const phone2Ref = useRef<any>(null);
  const phone3Ref = useRef<any>(null);
  const fax2Ref = useRef<any>(null);
  const fax3Ref = useRef<any>(null);
  const [addClinicData, setAddClinicData] = useState(initialStateAddClinic);
  const [AddorEditState, setAddorEditState] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data

  const doctorId: any = localStorage.getItem("doctorId");

  const LetAddNewClinic = async (values: any) => {
    try {
      const bodyData = {
        doctorId: doctorId,
        clinicExtraLocation: values.clinicExtraLocation,
        addressLineOne: values.addressLineOne,
        addressLineTwo: values.addressLineTwo,
        zip: values.zip,
        telephoneNo: values.telephoneNo,
        telephoneNo1: values.telephoneNo1,
        telephoneNo2: values.telephoneNo2,
        faxNo: values.faxNo,
        faxNo1: values.faxNo1,
        faxNo2: values.faxNo2,
        state: values.state,
        location: values.location,
        city: values.city,
        npi: values.npi,
        stateLicenseId: values.stateLicenseId,
        deaNo: values.deaNo,
      };
      const result = await MyProfileAddNewClinic(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setAddorEditState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          props.handleHidePopupClick();
          props.fetchApi();
        }, 2000);
      } else {
        setAddorEditState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setAddorEditState((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const Params = {
    doctorId: doctorId,
  };
  const { data, loading } = useFetch(Params, InitializeAddClinic, []);

  useEffect(() => {
    if (data[0]) {
      setAddClinicData(data[0]);
    }
  }, [data]);

  return (
    <>
      {loading ? (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          height={"30vh"}
        >
          <CircularProgress color="primary" />
        </Grid>
      ) : (
        <Formik
          initialValues={addClinicData}
          enableReinitialize={true}
          validationSchema={yup.object().shape({
            location: yup
              .string()
              .nullable()
              .required("Practice Name is Required")
              .max(32)
              .min(1),

            ClinicExtraName: yup
              .string()
              .nullable()
              .matches(
                /^[aA-zZ\s]+$/,
                "Middle Name should be alphabetic characters."
              )
              .min(0)
              .max(16),
            telephoneNo: yup
              .string()
              .nullable()
              .required("Code Required")
              .min(3, "Must be exactly 3 digits")
              .max(3, "Must be exactly 3 digits"),
            telephoneNo1: yup
              .string()
              .nullable()
              .min(3, "Must be exactly 3 digits")
              .max(3, "Must be exactly 3 digits")
              .required("Number Required"),
            telephoneNo2: yup
              .string()
              .nullable()
              .min(4, "Must be exactly 4 digits")
              .max(4, "Must be exactly 4 digits")
              .required("Number Required"),
            addressLineOne: yup
              .string()
              .required("addressLineOne is required")
              .nullable(),
            city: yup.string().required("City is required").nullable(),
            state: yup.string().nullable().required("State is Required"),
            zip: yup
              .string()
              .required("Zip is Required")
              .nullable()
              .min(5, "Must be exactly 5 digits")
              .max(5, "Must be exactly 5 digits"),
            faxNo: yup
              .string()
              .required("fax no is Required")
              .nullable()
              .min(3, "Must be exactly 3 digits")
              .max(3, "Must be exactly 3 digits"),
            faxNo1: yup
              .string()
              .required("fax no is Required")
              .nullable()
              .min(3, "Must be exactly 3 digits")
              .max(3, "Must be exactly 3 digits"),
            faxNo2: yup
              .string()
              .required("fax no is Required")
              .nullable()
              .min(4, "Must be exactly 4 digits")
              .max(4, "Must be exactly 4 digits"),
            npi: yup
              .string()
              .nullable()
              .min(10, "Must be exactly 10 digits")
              .max(10, "Must be exactly 10 digits"),
            deaNo: yup
              .string()
              .nullable()
              .matches(/^[A-Za-z]{2}\d{7}$/, "Please enter valid DEA"),
            stateLicenseId: yup
              .string()
              .nullable()
              .min(10, "Must be exactly 10 digits")
              .max(10, "Must be exactly 10 digits"),
          })}
          onSubmit={(values) => {
            LetAddNewClinic(values);
          }}
        >
          {(registerProps) => (
            <Form onSubmit={registerProps.handleSubmit}>
              <Grid
                container
                xs={12}
                alignItems="flex-start"
                justifyContent="space-between"
                spacing={1}
              >
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="lastname"
                    >
                      Practice Name
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="practiceName"
                          name="location"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.location}
                          onChange={registerProps.handleChange}
                          placeholder={"Enter Practice Name"}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="clinicextraname"
                      className="mr"
                    >
                      Clinic Extra Name
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="clinicextraname"
                          name="clinicExtraLocation"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.clinicExtraLocation}
                          onChange={registerProps.handleChange}
                          placeholder={"Enter Clinic Extra Name"}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="address"
                    >
                      Address
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="address"
                          name="addressLineOne"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.addressLineOne}
                          onChange={registerProps.handleChange}
                          placeholder="Enter address Line one"
                        />
                      </DRxInputStyle>
                      <DRxInputStyle marginTop={1}>
                        <DRxInput
                          id="address"
                          name="addressLineTwo"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.addressLineTwo}
                          onChange={registerProps.handleChange}
                          placeholder="Enter address Line two"
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="city"
                      className="mr"
                    >
                      City
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="city"
                          name="city"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.city}
                          onChange={registerProps.handleChange}
                          placeholder="Enter city"
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="State"
                    >
                      State
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>
                    <Box>
                      <DRxSelectStyle>
                        <DRxSelect2
                          id="State"
                          name="state"
                          value={registerProps.values.state}
                          options={
                            AllDropdwonsState?.statesOptions ?? [
                              { label: "", value: "" },
                            ]
                          }
                          onChange={(option: any, e: any) => {
                            registerProps.setFieldValue("state", e.props.value);
                          }}
                        />
                      </DRxSelectStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="zip"
                      className="mr"
                    >
                      Zip
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="zip"
                          name="zip"
                          type="number"
                          className=""
                          disabled={false}
                          value={registerProps.values.zip}
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "zip",
                              event.target.value.slice(0, 5)
                            );
                          }}
                          placeholder="Enter zip code"
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>

                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="teleH"
                    >
                      Telephone No
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    </Typography>{" "}
                    <Box>
                      <TelephoneStyle>
                        <Box>
                          <DRxInput
                            id="telephone"
                            name="telephoneNo"
                            type="number"
                            className=""
                            placeholder="Code"
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telephoneNo",
                                event.target.value.slice(0, 3)
                              );
                              if (event.target.value.length === 3) {
                                phone2Ref?.current?.focus();
                              }
                            }}
                          />{" "}
                        </Box>
                        <Box>
                          <DRxInput
                            id="telephone"
                            name="telephoneNo1"
                            type="number"
                            className=""
                            inputRef={phone2Ref}
                            placeholder="NO1"
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telephoneNo1",
                                event.target.value.slice(0, 3)
                              );
                              if (event.target.value.length === 3) {
                                phone3Ref?.current?.focus();
                              }
                            }}
                          />
                        </Box>
                        <Box>
                          <DRxInput
                            id="telephone"
                            name="telephoneNo2"
                            type="number"
                            inputRef={phone3Ref}
                            className=""
                            placeholder={"NO2"}
                            onChange={(event: any) => {
                              registerProps.setFieldValue(
                                "telephoneNo2",
                                event.target.value.slice(0, 4)
                              );
                            }}
                          />
                        </Box>
                      </TelephoneStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        className="mr"
                      >
                        Fax No
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <TelephoneStyle>
                          <Box>
                            {" "}
                            <DRxInput
                              id="fax"
                              name="faxNo"
                              className=""
                              type="number"
                              placeholder="Code"
                              onChange={(event: any) => {
                                registerProps.setFieldValue(
                                  "faxNo",
                                  event.target.value.slice(0, 3)
                                );
                                if (event.target.value.length === 3) {
                                  fax2Ref?.current?.focus();
                                }
                              }}
                            />{" "}
                          </Box>
                          <Box>
                            <DRxInput
                              id="fax1"
                              name="faxNo1"
                              type="number"
                              className=""
                              inputRef={fax2Ref}
                              placeholder="NO1"
                              onChange={(event: any) => {
                                registerProps.setFieldValue(
                                  "faxNo1",
                                  event.target.value.slice(0, 3)
                                );
                                if (event.target.value.length === 3) {
                                  fax3Ref?.current?.focus();
                                }
                              }}
                            />
                          </Box>
                          <Box>
                            <DRxInput
                              id="fax2"
                              name="faxNo2"
                              type="number"
                              className=""
                              placeholder={"NO2"}
                              inputRef={fax3Ref}
                              onChange={(event: any) => {
                                registerProps.setFieldValue(
                                  "faxNo2",
                                  event.target.value.slice(0, 4)
                                );
                              }}
                            />
                          </Box>
                        </TelephoneStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="npi"
                    >
                      NPI
                      {/* <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography> */}
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="npi"
                          name="npi"
                          type="text"
                          className=""
                          disabled={false}
                          value={registerProps.values.npi}
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "npi",
                              event.target.value.slice(0, 10)
                            );
                          }}
                          placeholder={"Enter NPI"}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="stateLicense"
                    >
                      State License
                      {/* <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography> */}
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="stateLicense"
                          name="stateLicenseId"
                          type="text"
                          disabled={false}
                          value={registerProps.values.stateLicenseId}
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "stateLicenseId",
                              event.target.value.slice(0, 10)
                            );
                          }}
                          placeholder={"Enter State License"}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>

                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="stateLicense"
                    >
                      DEA
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="dea"
                          name="deaNo"
                          className=""
                          disabled={false}
                          value={registerProps.values.deaNo}
                          onChange={(event: any) => {
                            registerProps.setFieldValue(
                              "deaNo",
                              event.target.value.slice(0, 9)
                            );
                          }}
                          placeholder={"Enter DEA"}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                {/* <Grid item xs={12} md={6}></Grid> */}

                <Grid item xs={12} md={6}>
                  <BtnSMGroupStyle marginTop={1} marginBottom={2}>
                    <YSButton
                      size="large"
                      className=""
                      color="secondary"
                      dataTestId="submitBtn"
                      variant="outlined"
                      disabled={false}
                      type="reset"
                      children={"Reset"}
                      onClick={() => {
                        setAddClinicData(initialStateAddClinic);
                      }}
                    />
                    <YSButton
                      size="large"
                      className=""
                      color="secondary"
                      dataTestId="submitBtn"
                      variant="outlined"
                      disabled={false}
                      type="button"
                      children={"Cancel"}
                      onClick={props.handleHidePopupClick}
                    />
                    <YSButton
                      size="large"
                      className=""
                      color="primary"
                      dataTestId="submitBtn"
                      variant="contained"
                      disabled={false}
                      type="submit"
                      children={"Submit"}
                      onClick={null}
                    />
                  </BtnSMGroupStyle>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      )}
      <YSSnackBar
        message={AddorEditState.message}
        variant={AddorEditState.variant}
        open={AddorEditState.open}
        handleClose={() => {
          setAddorEditState((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
